/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ModifyOtherSystemSourceInsightInput
 */
export interface ModifyOtherSystemSourceInsightInput {
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInsightInput
     */
    since?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInsightInput
     */
    until?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ModifyOtherSystemSourceInsightInput
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInsightInput
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInsightInput
     */
    id?: string;
}

/**
 * Check if a given object implements the ModifyOtherSystemSourceInsightInput interface.
 */
export function instanceOfModifyOtherSystemSourceInsightInput(value: object): value is ModifyOtherSystemSourceInsightInput {
    return true;
}

export function ModifyOtherSystemSourceInsightInputFromJSON(json: any): ModifyOtherSystemSourceInsightInput {
    return ModifyOtherSystemSourceInsightInputFromJSONTyped(json, false);
}

export function ModifyOtherSystemSourceInsightInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModifyOtherSystemSourceInsightInput {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'note': json['note'] == null ? undefined : json['note'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ModifyOtherSystemSourceInsightInputToJSON(json: any): ModifyOtherSystemSourceInsightInput {
    return ModifyOtherSystemSourceInsightInputToJSONTyped(json, false);
}

export function ModifyOtherSystemSourceInsightInputToJSONTyped(value?: ModifyOtherSystemSourceInsightInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'spend': MoneyOutputToJSON(value['spend']),
        'note': value['note'],
        'id': value['id'],
    };
}

